import React from 'react';
import './styles.css';


export const Popup = ({ text, closePopup }) => {
    return (
        <div className="popup-container" onClick={closePopup}>
            <div className="popup-body" onClick={closePopup}>
                <div className="popup-text">
                <h1>{text}HOLIDAY HOURS</h1>
                <h2>FRIDAY, APRIL 7, 2023</h2>
                    <h2>Apparel and Accessories: 10 am - 5 pm</h2>
                </div>
                <div className="popup-footer">
                    <button type="button" class="btn btn-primary w125" onClick={closePopup}>OK</button>
                </div>
            </div>
        </div>
    );
};


// WEBPACK FOOTER //
// ./src/components/Popup/popup.js